import { inject, Injectable } from '@angular/core';

import { LoginService } from 'app/services/data/login.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SentryLoggerService } from '../data/sentry-logger.service';

@Injectable()
export class AutoConnect {
    private _sentryLoggerService = inject(SentryLoggerService);
    constructor(
        private loginService: LoginService,
    ) { }

    canActivate(): Observable<boolean> {
        if (this.loginService.hasEffectiveSession()) {
            return of(true);
        }
        if (this.loginService.isConnected()) {
            return this.loginService.reConnect().pipe(
                map(() => {
                    this.loginService.redirectUser();
                    return false;
                }),
                catchError(() => {
                    this.loginService.logOut();
                    return of(true);
                })
            );
        }
        return of(true);
    }

}
